import apiClient from '../client';
import { BillingAddress, User } from '../types';

export const usersApi = {
  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/users/me/');
    return response.data;
  },

  updateMe: async (
    data: Partial<Pick<User, 'first_name' | 'last_name' | 'company_name'>>,
  ): Promise<User> => {
    const response = await apiClient.patch<User>('/users/me/', data);
    return response.data;
  },

  getBillingAddress: async (): Promise<BillingAddress> => {
    const response = await apiClient.get<BillingAddress>('/users/billing/');
    return response.data;
  },

  updateBillingAddress: async (data: Partial<BillingAddress>): Promise<BillingAddress> => {
    const response = await apiClient.patch<BillingAddress>('/users/billing/', data);
    return response.data;
  },

  createBillingAddress: async (data: BillingAddress): Promise<BillingAddress> => {
    const response = await apiClient.put<BillingAddress>('/users/billing/', data);
    return response.data;
  },
};

export default usersApi;
